export default function Chat() {

    let chatURL = process.env.PUBLIC_URL + "/llm-chat.html"
    return (
	    <iframe src={chatURL} className="w-full h-full"/>
    );
}
